import { SxProps } from '@mui/material';

export const CardLinkFrameSx: SxProps = {
	border: '1px solid #C9C9C9',
	height: '120px',
	minWidth: '200px',
	maxWidth: '200px',
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
	justifyContent: 'center',
	alignItems: 'center',
	borderRadius: 1.5,
	'&:hover': {
		backgroundColor: '#F0F7FF',
		border: '2px solid #011688',
		'& svg': {
			fill: '#011688',
		},
		'#shipping-deliveries-svg': {
			stroke: '#011688',
		},
		'#returns-svg': {
			stroke: '#011688',
		},
		'& p': {
			color: '#011688',
		},
	},
	'&:active': {
		backgroundColor: '#F0F7FF',
		border: '2px solid #011688',
		'& svg': {
			fill: '#011688',
		},
		'#shipping-deliveries-svg': {
			stroke: '#011688',
		},
		'#returns-svg': {
			stroke: '#011688',
		},
		'& p': {
			color: '#011688',
		},
	},
};

export const CardLinkNameSx: SxProps = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
	fontWeight: '600',
	textTransform: 'uppercase',
};
